// eslint-disable-next-line no-unused-vars
import { Resource, AudioResource } from './Resource'
/**
 * 用於預載所有音效或音樂的類別
 */
export class AudioManager{
  constructor(){
    /** @type {Object.<string, AudioResource>} */
    this.resourcesMap = {}
    /** @type {Object.<string, HTMLAudioElement>} */
    this.audiosMap = {}
  }
  preloadAll(){
    let list = Object.keys(this.resourcesMap)
    let promises = []
    for(let id of list){
      let res = this.resourcesMap[id]
      if(res.preload && this.audiosMap[res.id]){
        let audio = this.audiosMap[res.id] = new Audio(res.src)
        audio.preload = 'auto'
        promises.push(new Promise((resolve, reject)=>{
          audio.addEventListener('canplaythrough', resolve, false)
        }))
        document.getElementById('resources').appendChild(audio)
      }
    }
    return Promise.all(promises)
  }
  /**
   * @param {AudioResource} audioResource
   * @param {Object} opts
   */
  register(audioResource, opts = {}){
    if(this.resourcesMap[audioResource.id]){
      console.warn(`audio id duplicate ${audioResource.id}`)
    }
    this.resourcesMap[audioResource.id] = audioResource
  }
  /**
   * @param {AudioResource} audioResource
   * @param {Object} opts
   */
  add(audioResource, opts = {}){
    return this.register(audioResource, opts)
  }
  getAudioElement(id){
    return this.audiosMap[id]
  }
}
export const instance = new AudioManager()
AudioManager.instance = instance
export default instance
